import * as yup from "yup";

export const createAnswerTrueFalse = yup.object().shape({
  alternatives: yup.array().of(yup.mixed()).required('Você deve adicionar ao menos uma alternativa.').min(1),
  },
);
